import { usePlayground } from "../../contexts/PlaygroundContext";
import ModelResponseCard from "./ModelResponseCard";
import { getResponseKey } from "./types";
import { cn } from "../../lib/utils";

export default function PlaygroundResponseGrid() {
    const { state } = usePlayground();

    const isCompareModels = state.mode === 'compare-models';

    if (state.selectedModels.length === 0) {
        return (
            <div className="flex min-h-[200px] items-center justify-center rounded-md border-2 border-dashed border-border bg-muted/30">
                <p className="px-5 text-center text-sm text-muted-foreground">
                    {isCompareModels
                        ? 'Selecione modelos acima para começar a comparar respostas'
                        : 'Selecione um modelo acima para começar'}
                </p>
            </div>
        );
    }

    const hasResponses = Object.keys(state.responses).length > 0;

    const promptIndicesWithResponses = new Set(
        Object.keys(state.responses).map(key => {
            const dashIndex = key.indexOf('-');
            return parseInt(key.substring(0, dashIndex));
        })
    );

    const promptsToShow = state.userMessages
        .map((message, index) => ({ message, index }))
        .filter(({ message, index }) =>
            message.trim().length > 0 || promptIndicesWithResponses.has(index)
        );

    if (promptsToShow.length === 0 && !hasResponses) {
        return (
            <div className="flex min-h-[200px] items-center justify-center rounded-md border-2 border-dashed border-border bg-muted/30">
                <p className="px-5 text-center text-sm text-muted-foreground">
                    Digite pelo menos um prompt para gerar respostas
                </p>
            </div>
        );
    }

    if (!hasResponses) {
        return (
            <div className="flex min-h-[200px] items-center justify-center rounded-md border-2 border-dashed border-border bg-muted/30">
                <p className="px-5 text-center text-sm text-muted-foreground">
                    Clique em "Gerar Respostas" para comparar
                </p>
            </div>
        );
    }

    if (isCompareModels) {
        const promptIndex = promptsToShow[0]?.index || 0;
        const cols = state.selectedModels.length === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2';

        return (
            <div className="flex flex-col gap-4">
                <h2 className="text-[14px] font-bold text-foreground">Respostas dos Modelos</h2>
                <div className={cn("grid gap-4", cols)}>
                    {state.selectedModels.map((modelId) => (
                        <ModelResponseCard
                            key={modelId}
                            modelId={modelId}
                            response={state.responses[getResponseKey(promptIndex, modelId)]}
                            pricing={state.modelPricing[modelId]}
                        />
                    ))}
                </div>
            </div>
        );
    }

    const modelId = state.selectedModels[0];

    return (
        <div className="flex flex-col gap-4">
            <h2 className="text-[14px] font-bold text-foreground">Respostas para cada Prompt</h2>
            <span className="self-start rounded-md bg-primary/10 px-2.5 py-1 text-xs font-semibold text-primary">
                {modelId}
            </span>

            {promptsToShow.map(({ index: promptIndex }) => (
                <div
                    key={promptIndex}
                    className="flex flex-col gap-3 rounded-md border border-border/60 bg-muted/30 p-4"
                >
                    <span className="text-xs font-bold text-primary">Prompt {promptIndex + 1}</span>
                    <ModelResponseCard
                        modelId={modelId}
                        response={state.responses[getResponseKey(promptIndex, modelId)]}
                        pricing={state.modelPricing[modelId]}
                        hideModelName
                    />
                </div>
            ))}
        </div>
    );
}
